import React from 'react'
import PropTypes from 'prop-types'
import Lib from '../../loader'

/**
 * Use `Heading` to work with typography
 */

function Heading({
  children, className, level, color,
}) {
  return (
    <Lib.Heading level={level} color={color} className={className}>
      { children }
    </Lib.Heading>
  )
}

Heading.defaultProps = {
  level: 'h1',
  color: '#000',
  className: '',
  children: null,
}

Heading.propTypes = {
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  color: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
}

export default Heading
